module.exports = __webpack_public_path__ + "static/media/th-online-bg.11f466fa.svg";